/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real GridCraft budget sample. Use a small workbook like this for your first Excel compatibility check. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_imagecaption1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 的真实预算示例。首次测试 Excel 兼容性时，可从这种小型工作簿开始。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "A real GridCraft budget sample. Use a small workbook like this for your first Excel compatibility check. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_imagecaption1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagecaption1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_imagecaption1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_imagecaption1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_imagecaption1 as "gc.search_guides.gridcraft_excel_compatibility.imageCaption" }